import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Marquee from 'react-fast-marquee'
import { Box, Grid2 } from '@mui/material'
import Title from '../Title/Title'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const Events: React.FC = () => {
  type GroupItems = {
    id: number
    Name: string | null
    Link: string | null
    bgcolor: string | null
    Icon: {
      url: string
    }[]
  }

  const [logoList, setLogoList] = useState<GroupItems[]>([])
  const rootRef = useRef<HTMLDivElement>(null)

  const CACHE_KEY = 'logo_event_cache'
  const CACHE_TIMESTAMP_KEY = 'logo_event_cache_timestamp'
  const CACHE_DURATION = 5 * 60 * 1000

  const fetchData = async () => {
    try {
      const res = await axios.get(
        'https://app.dfopsa.online/api/logo-event?populate[logos][populate]=*'
      )
      const logos = res?.data?.data?.logos

      setLogoList(logos)

      localStorage.setItem(CACHE_KEY, JSON.stringify(logos))
      localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now().toString())
    } catch (error) {
      console.error('Failed to fetch logo data:', error)
    }
  }

  useEffect(() => {
    const cachedData = localStorage.getItem(CACHE_KEY)
    const cachedTime = localStorage.getItem(CACHE_TIMESTAMP_KEY)

    if (cachedData && cachedTime) {
      const now = Date.now()
      const age = now - parseInt(cachedTime, 10)

      if (age < CACHE_DURATION) {
        setLogoList(JSON.parse(cachedData))
      } else {
        fetchData()
      }
    } else {
      fetchData()
    }

    const interval = setInterval(fetchData, CACHE_DURATION)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (rootRef.current) {
      gsap.fromTo(
        rootRef.current,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: rootRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    }
  }, [logoList])

  return (
    <Box id='events' ref={rootRef}>
      <Grid2 size={{ xs: 10 }} sx={{ pb: 15 }}>
        <Title tag='h2'>Our Partners</Title>
      </Grid2>
      <Marquee pauseOnHover speed={30} gradient gradientWidth={100}>
        {logoList.map(item => (
          <div className='marquee-item' key={item.id}>
            <img
              src={`https://app.dfopsa.online${item?.Icon?.[0]?.url}`}
              height='50'
              alt={item?.Name || 'Logo'}
            />
          </div>
        ))}
      </Marquee>
    </Box>
  )
}

export default Events
